/*
 * View for a ckeditor dialog window for selecting a topic using a search bar.  The selected topic is shown below the bar.
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/shared/topicSelector/template/topicSelectorTemplate.html",
  "modules/typeahead/typeaheadModel",
], function (Marionette, $, Messenger, TopicSelectorTemplate) {
  const TopicSelectorView = {};

  TopicSelectorView.topicSelectorView = Marionette.ItemView.extend({
    template: TopicSelectorTemplate,
    modelEvents: {
      sync: "render",
    },
    noTopicError: function () {
      const errorMessage = $.t("ckeditor.topicLink.noTopicError");
      this.$el
        .find("#topicError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    onRender: function () {
      this.$el.i18n();
      //set up source function to get the typeahead data
      const sourceFunction = (query, process) => {
        const results = Messenger.reqres.request("topics:typeahead", query);
        results.once("sync", () => process(results.getResultsArray()));
      };

      this.$el.find("input").typeahead({
        source: sourceFunction,
        updater: (item) => {
          //set the value of the textbox
          this.$el.find("input").val(item);
          this.trigger("search", item); //trigger event on view, passing the search query
          return item;
        },
      });
    },
  });

  return TopicSelectorView;
});
